import { gql } from '@apollo/client';

export const CREATE_SEASON = gql`
    mutation CreateSeason($input:CreateSeasonInput!) {
    createSeason(input: $input) {
        error {
            message
        }
        data {
            video_season {
                created_at
                folder_id
                id
                label
                series_id
                title
                updated_at
            }
        }
    }
}

`;
export const UPDATE_SEASON = gql`
    mutation UpdateSeason($input:UpdateSeasonInput) {
        updateSeason(input: $input) {
           error {
            message
        }
        data {
            video_season {
                created_at
                folder_id
                id
                label
                series_id
                title
                updated_at
            }
        }
    }
}
`;
export const DELETE_SEASON = gql`
    mutation DeleteSeason($folder_id: String, $season_id: UUID) {
    deleteSeason(folder_id: $folder_id, season_id: $season_id) {
        error {
           message
            code
            field
        }
        data {
            message
        }
    }
}
`;